import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const SectionHeader = ({ title, subtitle, action }) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={1.5}
    alignItems={{ xs: 'flex-start', md: 'center' }}
    justifyContent="space-between"
    sx={{ mb: 2.5 }}
  >
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
    {action}
  </Stack>
);

export default SectionHeader;
